export const projectsConfig = {
  categories: {
    webApps: 'Web Applications',
    tools: 'Developer Tools',
    experiments: 'Experiments',
    games: 'Games',
  },

  projects: [
    {
      id: 'polaroid-framer',
      title: 'Polaroid Framer',
      description:
        'Add retro polaroid frames to your photos with custom captions',
      category: 'webApps',
      status: 'live',
      technologies: ['React', 'HTML5 Canvas', 'Vite', 'Tailwind CSS'],

      deployment: {
        type: 'subdomain',
        url: 'https://photo-framer.haseebkhan.ca',
        embedUrl: 'https://photo-framer.haseebkhan.ca?embedded=true',
        repository: 'https://github.com/haseebk/polaroid-framer',
      },

      display: {
        thumbnail: '/images/projects/photo-framer-thumbnail.png',
        screenshots: [
          '/images/projects/polaroid-framer-1.jpg',
          '/images/projects/polaroid-framer-2.jpg',
        ],
        featured: false,
        launchType: 'subdomain',
        showInPortfolio: true,
      },

      createdDate: '2025-05-21',
      lastUpdated: '2025-05-22',
      version: '1.0.0',
    },

    {
      id: 'ai-tinerary',
      title: 'Trippler',
      description:
        'An AI-powered trip planning application that generates personalized itineraries',
      category: 'webApps',
      status: 'development',
      technologies: [
        'Next.js',
        'TypeScript',
        'Prisma',
        'OpenAI API',
        'NextAuth',
        'Tailwind CSS',
        'Google Maps API',
        'Radix UI',
      ],

      deployment: {
        type: 'external',
        url: 'https://trippler.ca',
        repository: 'https://github.com/haseebk/ai-tinerary',
      },

      display: {
        thumbnail: '/images/projects/trippler-thumbnail.png',
        featured: true,
        launchType: 'subdomain',
        showInPortfolio: true,
      },

      createdDate: '2025-01-22',
      lastUpdated: '2025-01-22',
      version: '0.1.0',
    },
    {
      id: 'finberry',
      title: 'Finberry',
      description:
        'A simulated investing application built with real-time market data',
      category: 'webApps',
      status: 'development',
      technologies: [
        'React',
        'Node.js',
        'Express.js',
        'MongoDB',
        'TwelveData API',
        'Firebase',
      ],

      deployment: {
        type: 'external',
        url: 'https://finberry.ca',
        repository: '',
      },

      display: {
        thumbnail: '/images/projects/finberry-thumbnail.png',
        featured: false,
        launchType: 'external',
        showInPortfolio: true,
      },

      createdDate: '2022-09-22',
      lastUpdated: '2023-05-12',
      version: '1.0.0',
    },

    {
      id: 'cantax',
      title: 'CanTax',
      description:
        'Canadian income and sales tax calculator with province selection and bilingual (English/French) support',
      category: 'tools',
      status: 'live',
      technologies: ['SwiftUI', 'Swift', 'SwiftData'],

      deployment: {
        type: 'external',
        url: 'https://apps.apple.com/ca/app/cantax/id6760609061',
        repository: 'https://github.com/haseebkhan/cantax-calculator',
      },

      display: {
        featured: false,
        launchType: 'external',
        showInPortfolio: true,
      },

      createdDate: '2025-01-01',
      lastUpdated: '2026-04-08',
      version: '1.0.0',
    },

    {
      id: 'stickit',
      title: 'StickIt',
      description:
        'iOS sticker creation app with AI-powered subject detection, multiple selection tools, and iMessage sticker pack support',
      category: 'tools',
      status: 'live',
      technologies: ['SwiftUI', 'Swift', 'Vision Framework', 'CoreImage', 'SwiftData'],

      deployment: {
        type: 'external',
        url: 'https://apps.apple.com/ca/app/stickit-custom-sticker-maker/id6760530357',
        repository: 'https://github.com/haseebkhan/stick-it',
      },

      display: {
        featured: false,
        launchType: 'external',
        showInPortfolio: true,
      },

      createdDate: '2025-01-01',
      lastUpdated: '2026-04-08',
      version: '1.0.0',
    },

    {
      id: 'soundcanvas',
      title: 'SoundCanvas',
      description:
        'Spotify music visualization tool with interactive 3D force-graph representations of your listening data',
      category: 'webApps',
      status: 'live',
      technologies: ['Next.js', 'TypeScript', 'Three.js', 'Spotify API', 'Supabase', 'Tailwind CSS'],

      deployment: {
        type: 'external',
        url: 'https://vibe-map.vercel.app/',
        repository: 'https://github.com/haseebkhan/vibe-map',
      },

      display: {
        featured: false,
        launchType: 'external',
        showInPortfolio: true,
      },

      createdDate: '2025-01-01',
      lastUpdated: '2026-04-08',
      version: '1.0.0',
    },

    {
      id: 'ios-icon-sizer',
      title: 'iOS Icon Sizer',
      description:
        'Upload a single image and get a ZIP of all required iOS, iPad, Mac, and watchOS icon sizes',
      category: 'tools',
      status: 'live',
      technologies: ['Next.js', 'TypeScript', 'Tailwind CSS', 'jszip'],

      deployment: {
        type: 'external',
        url: 'http://iconsizer.app',
        repository: 'https://github.com/haseebkhan/ios-icon-sizer',
      },

      display: {
        featured: false,
        launchType: 'external',
        showInPortfolio: true,
      },

      createdDate: '2025-01-01',
      lastUpdated: '2026-04-08',
      version: '1.0.0',
    },
  ],
}

export const getProjectById = (id) => {
  return projectsConfig.projects.find((project) => project.id === id)
}

export const getProjectsByCategory = (category) => {
  return projectsConfig.projects.filter(
    (project) => project.category === category
  )
}

export const getFeaturedProjects = () => {
  return projectsConfig.projects.filter((project) => project.display.featured)
}

export const getLiveProjects = () => {
  return projectsConfig.projects.filter((project) => project.status === 'live')
}

export const getProjectsByTechnology = (tech) => {
  return projectsConfig.projects.filter((project) =>
    project.technologies.includes(tech)
  )
}
